module.exports = __webpack_public_path__ + "static/7-e3a41990c9c8c67066e2cb67a034c1bd.jpg";